(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galil-roast-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
    var forms = document.querySelectorAll('[data-galil-quiz]:not([data-quiz-ready])');
    forms.forEach(function (form) {
      form.dataset.quizReady = 'true';
      var section = form.closest('.galil-quiz');
      var results = section.querySelector('[data-quiz-results]');
      var steps = form.querySelectorAll('[data-step]');
      var back = form.querySelector('[data-quiz-back]');
      var stepLabel = form.querySelector('[data-quiz-step]');
      var current = 1;
      form.hidden = false;

      function show(n) {
        current = n;
        steps.forEach(function (s) { s.hidden = Number(s.dataset.step) !== n; });
        back.hidden = n === 1;
        stepLabel.textContent = n;
        var legend = form.querySelector('[data-step="' + n + '"] legend');
        if (legend) legend.focus({ preventScroll: true });
      }

      function value(name) {
        var el = form.querySelector('input[name="' + name + '"]:checked');
        return el ? el.value : '';
      }

      function pick() {
        var brew = value('brew'), taste = value('taste'), caf = value('caf');
        if (caf === 'decaf') return 'decaf';
        if (brew === 'none') return 'instant';
        if (taste === 'bold') return 'dark';
        if (taste === 'bright') return 'bright';
        return brew === 'drip' ? 'smooth_pour' : 'smooth';
      }

      function finish() {
        var key = pick();
        var cards = results.querySelectorAll('[data-outcome]');
        var card = results.querySelector('[data-outcome="' + key + '"]') || cards[0];
        if (!card) return;
        cards.forEach(function (c) { c.hidden = c !== card; });
        var note = card.querySelector('[data-quiz-nogear-note]');
        if (note) note.hidden = value('brew') !== 'none';
        form.hidden = true;
        results.hidden = false;
        var name = card.querySelector('.galil-quiz__result-name');
        if (name) name.focus({ preventScroll: true });
      }

      form.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        window.setTimeout(function () {
          if (current < steps.length) show(current + 1);
          else finish();
        }, 180);
      });

      back.addEventListener('click', function () { if (current > 1) show(current - 1); });

      results.addEventListener('click', function (e) {
        if (!e.target.closest('[data-quiz-restart]')) return;
        form.reset();
        results.hidden = true;
        form.hidden = false;
        show(1);
      });
    });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
